import { render, staticRenderFns } from "./BaseFeatureLocker.vue?vue&type=template&id=e5abf670&scoped=true&"
import script from "./BaseFeatureLocker.vue?vue&type=script&lang=js&"
export * from "./BaseFeatureLocker.vue?vue&type=script&lang=js&"
import style0 from "./BaseFeatureLocker.vue?vue&type=style&index=0&id=e5abf670&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5abf670",
  null
  
)

export default component.exports